import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import {
  getFirestore,
  connectFirestoreEmulator,
  enableIndexedDbPersistence,
} from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// ============================================================
// SETUP INSTRUCTIONS:
// 1. Go to https://console.firebase.google.com
// 2. Create a new project called "fieldnotes-app"
// 3. Enable Authentication (Email/Password provider)
// 4. Enable Cloud Firestore
// 5. Enable Cloud Storage
// 6. Enable Cloud Functions (requires Blaze plan)
// 7. Copy your config object from Project Settings > General
// 8. Replace the placeholder values below
// ============================================================

const firebaseConfig = {
  apiKey: "AIzaSyAYO4D6BmIjMa7XMs_wRiEkU_68h-eOIGc",
  authDomain: "fieldnotes-app-5c3ba.firebaseapp.com",
  projectId: "fieldnotes-app-5c3ba",
  storageBucket: "fieldnotes-app-5c3ba.firebasestorage.app",
  messagingSenderId: "25787022744",
  appId: "1:25787022744:web:056afb29ff544a0aa77fed",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Enable offline persistence for Firestore
// This is critical for the offline-first functionality
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === "failed-precondition") {
    // Multiple tabs open — persistence can only be enabled in one tab at a time
    console.warn(
      "Firestore persistence failed: Multiple tabs open. Offline mode limited to one tab."
    );
  } else if (err.code === "unimplemented") {
    // Browser doesn't support persistence
    console.warn(
      "Firestore persistence not available in this browser. Offline mode disabled."
    );
  }
});

// Connect to emulators in development
if (process.env.NODE_ENV === "development" && process.env.REACT_APP_USE_EMULATORS === "true") {
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, "localhost", 8080);
  connectStorageEmulator(storage, "localhost", 9199);
  connectFunctionsEmulator(functions, "localhost", 5001);
  console.log("🔧 Connected to Firebase Emulators");
}

export default app;